/**
 * PWA-Bootstrap für das Eltern-Portal:
 * - eigenes Manifest (scope /portal/)
 * - Service Worker (Installierbarkeit)
 * - Theme-Farbe / Apple-Titel
 */

let _bootstrapped = false;

export function bootstrapPortalPwa() {
  if (typeof document === 'undefined' || _bootstrapped) return;
  _bootstrapped = true;

  // Manifest auf Portal-Variante umschalten
  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'manifest';
    document.head.appendChild(link);
  }
  link.href = `${process.env.PUBLIC_URL || ''}/portal-manifest.json`;

  // Theme / iOS Homescreen
  let theme = document.querySelector('meta[name="theme-color"]');
  if (!theme) {
    theme = document.createElement('meta');
    theme.name = 'theme-color';
    document.head.appendChild(theme);
  }
  theme.content = '#5b21b6';

  let appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (!appleTitle) {
    appleTitle = document.createElement('meta');
    appleTitle.name = 'apple-mobile-web-app-title';
    document.head.appendChild(appleTitle);
  }
  appleTitle.content = 'Eltern-Portal';

  document.title = 'Eltern-Portal · Musik Akademie';

  // Service Worker für Installierbarkeit (gleicher SW wie Mobile — Push-URLs bleiben /m)
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/sw.js`).catch(() => {});
  }
}
